import type { ApolloCache } from '@apollo/client';
import GET_ME from 'graph/user/get-me-query';
import { UserSetting } from 'types/schema-generated-types';


const updateUserSettingCache = (cache: ApolloCache<any>, updatedSetting: UserSetting) => {
  const cachedData = cache.readQuery<{ me?: { settings?: any[] } }>({ query: GET_ME });
  const cachedSettings = cachedData?.me?.settings;

  if (!cachedData?.me || !cachedSettings) return;

  const cachedSetting = cachedSettings.some(setting => setting?.id === updatedSetting.id);
  if (cachedSetting) return;

  cache.writeQuery({
    query: GET_ME,
    data: {
      ...cachedData,
      me: { ...cachedData.me, settings: [...cachedSettings, updatedSetting] }
    }
  });
};

export default updateUserSettingCache;